import app from 'firebase/compat/app';
import 'firebase/compat/auth';
import { OAuthProvider, signInWithPopup, fetchSignInMethodsForEmail  } from 'firebase/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyB6RppFJIigqAxyMRjzJg49IiUZnE8IVd4",
  authDomain: "portal-gestion-academica-uat.firebaseapp.com",
  projectId: "portal-gestion-academica-uat",
  storageBucket: "gs://portal-gestion-academica-uat.appspot.com",
  messagingSenderId: "861386102065",
  appId: "1:861386102065:web:dbf928ddad7f27b85ccc10",
  measurementId: "G-J8CBM55ZFS"
};

app.initializeApp(firebaseConfig);
const provider = new OAuthProvider('microsoft.com');
const firebase = app.firestore()
const auth = app.auth()
const storage = app.storage()
const analytics = app.analytics();

export { firebase, auth, storage, provider, signInWithPopup, fetchSignInMethodsForEmail, analytics }
